module.exports = require("./ar-ER");